import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { AiAutocompletePluginState } from '../types/types';

export const aiAutocompletePluginKey: PluginKey<AiAutocompletePluginState> =
	new PluginKey<AiAutocompletePluginState>('aiAutocompletePlugin');
